import * as React from 'react';
import { PureComponent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobVacancy } from '../../Model/JobVacancy';
import { ShowIcon } from './ShowIcon';

interface ApplyForButtonProps {
    model: JobVacancy,
    showIcon?: ShowIcon
}

/**
 * Button to apply for **one** single Job Vacancy
 */
export class ApplyForButton extends PureComponent<ApplyForButtonProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: ApplyForButtonProps, context: AppContext) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
    }

    public render() {
        const props = this.props;
        const title = this.context.i18n.translate('Auf diese Stelle bewerben');
        const showIcon = props.showIcon;
        const iconBefore = showIcon === ShowIcon.Left ? <i className="fas fa-user-chart"/> : null;
        const iconAfter = showIcon === ShowIcon.Right ? <i className="fas fa-user-chart"/> : null;

        return <button className="jc-apply-now-button primary candidate" title={title} onClick={this.handleClick}>
            {iconBefore}
            <span>{title}</span>
            {iconAfter}
        </button>;
    }

    private handleClick() {
        this.context.applyTo(this.props.model);
    }
}
